import { useTranslation } from '@mukil/i18n';
import { groupSecret } from '../../lib/auth/two_factor_logic.js';

/**
 * "Scan this with your authenticator app" — the server-rendered QR code
 * (`qr_svg`, a `data:image/svg+xml` URI built from the `otpauth://` URI) and
 * the same secret as text for typing in by hand. Rendered from the server's
 * response only: the secret never goes to a third-party QR service.
 */
export function AuthenticatorSetupCard({
  qrSvg,
  secret,
}: {
  qrSvg: string;
  secret: string;
}): React.JSX.Element {
  const { t } = useTranslation('wp');
  return (
    <div className="flex flex-col items-center gap-3 sm:flex-row sm:items-start sm:gap-5">
      <img
        src={qrSvg}
        alt={t('two_factor.qr_alt')}
        width={168}
        height={168}
        className="rounded-lg border border-[color:var(--line)] bg-white p-2"
      />
      <div className="flex flex-col gap-2 text-sm">
        <p className="text-[color:var(--ink)]">{t('two_factor.scan_step')}</p>
        <p className="text-[color:var(--ink-muted)]">
          {t('two_factor.manual_key_label')}
        </p>
        <code className="mono select-all break-all rounded-md bg-[color:var(--line)] px-2 py-1 text-[13px] text-[color:var(--ink)]">
          {groupSecret(secret)}
        </code>
      </div>
    </div>
  );
}
